export enum FileType {
  LOGO = 'LOGO',
  WORD_MARK = 'WORD_MARK',
  PROFILE = 'PROFILE',
}

export type UploadResponse = {
  url: string;
};
